import { type UseMutationOptions, useMutation } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import { httpUpdateStepToCompleted } from '@/features/photoset/http/photoset.http'
import { MUTATION_KEYS } from '@/query-client'

export const useUpdateStepToCompleted = (
	options?: Omit<
		UseMutationOptions<
			unknown,
			AxiosError,
			{
				photosetId: number
				imagesIds: number[]
			}
		>,
		'mutationFn' | 'mutationKey'
	>
) =>
	useMutation({
		...options,
		mutationKey: [MUTATION_KEYS.UPDATE_STEP_COMPLETED],
		mutationFn: (variables) => httpUpdateStepToCompleted(variables)
	})
